// components/onboarding/OnboardingFlow.js
import React, { useState } from 'react';
import IntegrationsOnboarding from './IntegrationsOnboarding';

const OnboardingFlow = ({ user, onComplete, api }) => {
  const [isCompleting, setIsCompleting] = useState(false);

  const handleComplete = async () => {
    setIsCompleting(true);
    try {
      await api.completeOnboarding();
      onComplete();
    } catch (error) {
      console.error('Failed to complete onboarding:', error);
      setIsCompleting(false);
    }
  };

  // Show loading while completing
  if (isCompleting) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-3 border-purple-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Completing setup...</p>
        </div>
      </div>
    );
  }

  // Show the integrations onboarding hub
  return (
    <IntegrationsOnboarding
      user={user}
      onComplete={handleComplete}
      onSkip={handleComplete}
      api={api}
      isCompleting={isCompleting}
    />
  );
};

export default OnboardingFlow;